/**
 * Чистые форматтеры и подсказки справочника контрагентов (СПР-1a) — под unit-тест
 * (frontend/tests/unit/counterparties-format.test.mjs). Без обращения к DOM и API.
 */

export const KINDS = ['legal', 'ip', 'self_employed', 'person', 'gov'];
export const ROLES = ['customer', 'contractor', 'expertise', 'supervisor', 'supplier', 'other'];
export const PERSON_ROLES = ['expert', 'contact', 'contractor'];

export const KIND_LABELS = {
  legal: 'Юрлицо',
  ip: 'ИП',
  self_employed: 'Самозанятый',
  person: 'Физлицо',
  gov: 'Госорган',
};

export const ROLE_LABELS = {
  customer: 'Заказчик',
  contractor: 'Подрядчик (организация)',
  expertise: 'Экспертиза',
  supervisor: 'Надзор',
  supplier: 'Поставщик',
  other: 'Другое',
};

export const PERSON_ROLE_LABELS = {
  expert: 'Эксперт',
  contact: 'Контакт',
  contractor: 'Подрядчик',
};

export function kindLabel(k) {
  return KIND_LABELS[k] ?? k ?? '—';
}

export function rolesLabel(rs, labels = ROLE_LABELS) {
  const out = (rs ?? []).map(r => labels[r] ?? r).join(', ');
  return out || '—';
}

/** Какие реквизиты и какой ИНН показывать по виду контрагента. */
export function fieldsForKind(kind) {
  const legalGov = kind === 'legal' || kind === 'gov';
  return {
    orgForm: legalGov,
    kpp: legalGov,
    ogrn: legalGov || kind === 'ip',       // ОГРН (13) у юрлиц/госорганов, ОГРНИП (15) у ИП
    snils: kind === 'person' || kind === 'self_employed',
    innLen: legalGov ? 10 : 12,
  };
}

export function innHint(kind) {
  return fieldsForKind(kind).innLen === 10 ? '10 цифр' : '12 цифр';
}

/** Контрольная сумма ИНН (зеркало backend) — для подсветки в форме. */
export function validateInnClient(raw) {
  const inn = String(raw ?? '').replace(/\D/g, '');
  const csum = (digits, weights) =>
    weights.reduce((s, w, i) => s + Number(digits[i]) * w, 0) % 11 % 10;
  if (inn.length === 10) {
    return csum(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[9]);
  }
  if (inn.length === 12) {
    const n11 = csum(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
    const n12 = csum(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
    return n11 === Number(inn[10]) && n12 === Number(inn[11]);
  }
  return false;
}

/** Строка-сводка отчёта автосбора. */
export function collectSummary(res) {
  const cp = res.counterparties ?? {};
  const pp = res.persons ?? {};
  const fk = Object.values(res.fk_set ?? {}).reduce((a, b) => a + b, 0);
  const verb = res.apply ? 'Записано' : 'Будет записано';
  return `${verb}: контрагентов — создано ${cp.created ?? 0}, найдено ${cp.matched ?? 0}; `
    + `людей — создано ${pp.created ?? 0}; связей проставлено ${fk}`;
}
